export default class ProdutoInfo {
  constructor(
    data_emissao = '1899-12-30',
    desconto = 0,
    descricao = '',
    id_produto,
    id_unidade,
    preco_bruto = 0.00,
    preco_unitario = 0.00,
    qtde_produto = 0,
    qtde_unidade = 0,
    subtotal_produto = 0,
    unidade = '',
  ) {
    this.data_emissao = data_emissao;
    this.desconto = desconto;
    this.descricao = descricao;
    this.id_produto, id_produto;
    this.id_unidade, id_unidade;
    this.preco_bruto = preco_bruto;
    this.preco_unitario = preco_unitario;
    this.qtde_produto = qtde_produto;
    this.qtde_unidade = qtde_unidade;
    this.subtotal_produto = subtotal_produto;
    this.unidade = unidade;
  }
}